<template>
  <div>
    <v-layout row v-if="toPublish">
      <v-alert
        :value="true"
        type="warning"
        color="orange darken-2"
        style="width: 100%"
      >
        <span
          v-html="
            getString(
              'Ora sei nel mondo di <b>QuickBe</b>, ma il tuo negozio non è ancora pubblicato. Completa la configurazione e poi premi sul bottone <b>PUBBLICA</b>. Non preoccuparti, potrai sempre aggiornare tutte le informazion anche dopo!  :)'
            )
          "
        ></span>
        <v-btn @click="publish = true" color="success darken-1">{{
          getString("Pubblica")
        }}</v-btn>
      </v-alert>
    </v-layout>
    <v-dialog v-model="publish" max-width="500px">
      <v-card>
        <v-progress-linear
          indeterminate
          active
          v-if="loadPublish"
          color="red lighten-2"
        ></v-progress-linear>
        <v-card-title>
          <span class="headline">{{
            getString("Conferma pubblicazione")
          }}</span>
        </v-card-title>
        <v-card-text>
          <p
            v-html="
              getString(
                `<b>Attenzione</b>, confermando la pubblicazione il negozio diventerà visibile sulla piattaforma. Controlla di aver completato l'intera configurazione.`
              )
            "
          ></p>
        </v-card-text>
        <v-card-actions>
          <v-btn class="q-orange" flat @click="publish = false">{{
            getString("Chiudi")
          }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="q-orange" flat @click="publishShop">{{
            getString("Pubblica")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-tabs v-model="active" color="transparent" slider-color="red lighten-3">
      <v-tab
        v-for="(n, index) in tabs"
        :key="n"
        ripple
        @click="selected = index"
      >
        {{ n }}
      </v-tab>
      <v-tabs-items touchless>
        <v-tab-item :lazy="true" style="margin-top: 10px">
          <shop-desc
            :tab="selected"
            @siteAlert="(e) => this.$emit('siteAlert', e)"
            @siteAlertSuccess="(e) => this.$emit('siteAlertSuccess', e)"
            @siteAlertInfo="(e) => this.$emit('siteAlertInfo', e)"
            :shopID="selectedShop"
          ></shop-desc>
        </v-tab-item>
        <v-tab-item :lazy="true" style="margin-top: 10px">
          <shop-services
            :tab="selected"
            @siteAlert="(e) => this.$emit('siteAlert', e)"
            @siteAlertSuccess="(e) => this.$emit('siteAlertSuccess', e)"
            @siteAlertInfo="(e) => this.$emit('siteAlertInfo', e)"
            :shopID="selectedShop"
          ></shop-services>
        </v-tab-item>
        <v-tab-item :lazy="true" style="margin-top: 10px">
          <shop-openings
            :tab="selected"
            @siteAlert="(e) => this.$emit('siteAlert', e)"
            @siteAlertSuccess="(e) => this.$emit('siteAlertSuccess', e)"
            @siteAlertInfo="(e) => this.$emit('siteAlertInfo', e)"
            :shopID="selectedShop"
          ></shop-openings>
        </v-tab-item>
        <v-tab-item :lazy="true" style="margin-top: 10px">
          <shop-closing
            :tab="selected"
            @siteAlert="(e) => this.$emit('siteAlert', e)"
            @siteAlertSuccess="(e) => this.$emit('siteAlertSuccess', e)"
            @siteAlertInfo="(e) => this.$emit('siteAlertInfo', e)"
            :shopID="selectedShop"
          ></shop-closing>
        </v-tab-item>
        <v-tab-item :lazy="true" style="margin-top: 10px">
          <shop-galleries
            :tab="selected"
            @siteAlert="(e) => this.$emit('siteAlert', e)"
            @siteAlertSuccess="(e) => this.$emit('siteAlertSuccess', e)"
            @siteAlertInfo="(e) => this.$emit('siteAlertInfo', e)"
            :shopID="selectedShop"
          ></shop-galleries>
        </v-tab-item>
        <v-tab-item :lazy="true" style="margin-top: 10px">
          <shop-employees
            :tab="selected"
            @siteAlert="(e) => this.$emit('siteAlert', e)"
            @siteAlertSuccess="(e) => this.$emit('siteAlertSuccess', e)"
            @siteAlertInfo="(e) => this.$emit('siteAlertInfo', e)"
            :shopID="selectedShop"
          ></shop-employees>
        </v-tab-item>
        <!-- <v-tab-item :lazy="true">
          <shop-users
            :tab="selected"
            @siteAlert="(e) => this.$emit('siteAlert', e)"
            @siteAlertSuccess="(e) => this.$emit('siteAlertSuccess', e)"
            @siteAlertInfo="(e) => this.$emit('siteAlertInfo', e)"
            :shopID="selectedShop"
          ></shop-users>
        </v-tab-item> -->
        <v-tab-item :lazy="true">
          <shop-options
            :tab="selected"
            @siteAlert="(e) => this.$emit('siteAlert', e)"
            @siteAlertSuccess="(e) => this.$emit('siteAlertSuccess', e)"
            @siteAlertInfo="(e) => this.$emit('siteAlertInfo', e)"
            :shopID="selectedShop"
          ></shop-options>
        </v-tab-item>
        <v-tab-item :lazy="true">
          <shop-maintenance
            :tab="selected"
            @siteAlert="(e) => this.$emit('siteAlert', e)"
            @siteAlertSuccess="(e) => this.$emit('siteAlertSuccess', e)"
            @siteAlertInfo="(e) => this.$emit('siteAlertInfo', e)"
            :shopID="selectedShop"
          ></shop-maintenance>
        </v-tab-item>
        <!-- <v-tab-item :lazy="true">
          <shop-plaza
            :tab="selected"
            @siteAlert="(e) => this.$emit('siteAlert', e)"
            @siteAlertSuccess="(e) => this.$emit('siteAlertSuccess', e)"
            @siteAlertInfo="(e) => this.$emit('siteAlertInfo', e)"
            :shopID="selectedShop"
          ></shop-plaza>
        </v-tab-item> -->
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import ShopDesc from "./pieces/ShopDesc";
import ShopEmployees from "./pieces/ShopEmployees";
import ShopGalleries from "./pieces/ShopGalleries";
import ShopOpenings from "./pieces/ShopOpenings";
import ShopClosing from "./pieces/ShopClosing";
import ShopOptions from "./pieces/ShopOptions";
import ShopUsers from "./pieces/ShopUsers";
import ShopMaintenance from "./pieces/ShopMaintenance";
import ShopPlaza from "./pieces/ShopPlaza";
import ajax from "../../ajax";
import ShopServices from './pieces/ShopServices.vue';

export default {
  name: "Shops",
  components: {
    ShopUsers,
    ShopServices,
    ShopOptions,
    ShopOpenings,
    ShopGalleries,
    ShopClosing,
    ShopDesc,
    ShopEmployees,
    ShopMaintenance,
    ShopPlaza,
  },
  mounted: function () {
    //this.selectedShop = this.$route.params.id
    //this.selectedShop = this.$store.getters.myShop.idBarberShop;
    if (this.selectedShop > 0) {
      this.init();
    }
  },
  watch: {
    $route(to, from) {
      this.selectedShop = to.params.id;
    },

    selectedShop: function () {
      if (this.selectedShop > 0) {
        this.init();
      }
    },
  },
  computed: {
    selectedShop: function () {
      if (this.$store.getters.myShop)
        return this.$store.getters.myShop.idBarberShop;
    },
    toPublish: function () {
      return this.$store.getters.shopState === 2;
    },
  },
  data: () => {
    return {
      h: null,
      active: null,
      tabs: [],
      //  selectedShop: 0,
      selected: 0,
      publish: false,
      shopState: 1,
      loadPublish: false,
    };
  },
  methods: {
    publishShop: function () {
      let self = this;
      this.loadPublish = true;
      ajax.axios
        .put(
          ajax.baseUrl() +
            "/admin/shops/shop/" +
            self.selectedShop +
            "/publish",
          {},
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          self.$emit("siteAlertSuccess", response.data.data);
          location.href = "/admin/shops/" + self.selectedShop;
          self.loadPublish = false;
        })
        .catch(function (error) {
          self.loadPublish = false;
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    init: function () {
      this.tabs = [
        this.getString("Negozio"),
        this.getString("Servizi"),
        this.getString("Orari"),
        this.getString("Giorni di chiusura"),
        this.getString("Gallerie"),
        this.getString("Dipendenti"),
        // this.getString("Clienti"),
        this.getString("Opzioni"),
        this.getString("Manutenzione"),
        // this.getString("Plaza"),
      ];
    },
    getString: function (key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
  },
};
</script>

<style>
.q-dark-bk {
  background-color: #424242 !important;
}

.q-dark-text {
  color: #f5f5f5 !important;
}

.q-light-bk {
  color: #f5f5f5 !important;
}

.q-light-text {
  color: #424242 !important;
}

.full-width {
  width: 100% !important;
}

h1,
h2,
h3 {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/Shops.vue